import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { TermsPage } from "./terms";
import { LOCALIZED_LANGS, type Lang } from "../lib/i18n";

// Same story as the privacy notice: linked from every localised footer and
// 404 on all five. The identification block that art. 3:15d BW requires has to
// be reachable, and "reachable" does not mean reachable only in English.
export const Route = createFileRoute("/$locale/terms")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/terms" });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  head: () => ({
    meta: [
      { title: "Terms and who we are | sunbedly" },
      {
        name: "description",
        content:
          "Who runs sunbedly, what the service is and is not, how listings and prices work, and the terms that apply when you use the site.",
      },
    ],
  }),
  component: TermsPage,
});
